// extracted by mini-css-extract-plugin
export var autoExpand = "_2h-8";
export var container = "_2h-7";
export var containerWidth = "_2h-5";
export var disabled = "_2h-2";
export var error = "_2h-3";
export var fullWidth = "_2h-6";
export var inputWrapper = "_2h-0";
export var small = "_2h-1";
export var textarea = "_2h-4";